// A fancyful icons demo page; props and credits to,
// https://roobinium.io/, for a beatiful and easy to use design.

import { DemoHeader, DemoInfoBox } from '@/components/demo';
// Import 24x24 icons
import ArrowLeftIcon from '@/assets/img/icon/22x24/arrow-left.svg';
import ArrowRightIcon from '@/assets/img/icon/22x24/arrow-right.svg';
import ArrowUpIcon from '@/assets/img/icon/22x24/arrow-up.svg';
import ArrowDownIcon from '@/assets/img/icon/22x24/arrow-down.svg';
import DiscordSmallIcon from '@/assets/img/icon/22x24/discord.svg';
import HamburgerIcon from '@/assets/img/icon/22x24/hamburger.svg';
import StarIcon from '@/assets/img/icon/22x24/star.svg';
import TelegramSmallIcon from '@/assets/img/icon/22x24/telegram.svg';
import XCloseIcon from '@/assets/img/icon/22x24/x-close.svg';
import XComIcon from '@/assets/img/icon/22x24/x-com.svg';

// Import big icons
import XComBig from '@/assets/img/icon/big/x-com.svg';
import DiscordBigIcon from '@/assets/img/icon/big/discord.svg';
import KickIcon from '@/assets/img/icon/big/kick.svg';
import TelegramBigIcon from '@/assets/img/icon/big/telegram.svg';
import YoutubeIcon from '@/assets/img/icon/big/youtube.svg';

export const IconsDemo = () => {
    return (
        <div className="min-h-screen p-12">
            <div className="max-w-6xl mx-auto space-y-16">
                <DemoHeader badge="#assets" title="icons" />

                <DemoInfoBox 
                    description={
                        <>
                            Icons are accessed as <span className="text-primary font-bold">imported SVG files</span>, not React components. 
                            Import them directly and use as <code className="px-2 py-1 bg-base-300 rounded text-sm">src</code> attributes in <code className="px-2 py-1 bg-base-300 rounded text-sm">&lt;img&gt;</code> tags.
                        </>
                    }
                    example="import StarIcon from '@/assets/img/icon/22x24/star.svg'"
                />

                {/* 24x24 Icons Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">24x24</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">5 icons</p>
                    </div>
                    
                    {/* Navigation Icons */}
                    <div className="space-y-4">
                        <div className="flex items-center gap-8">
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={XCloseIcon} alt="Close" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">x-close.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={StarIcon} alt="Star" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">star.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={ArrowRightIcon} alt="Arrow Right, outline" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">arrow-right.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={ArrowLeftIcon} alt="Arrow Left, outline" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">arrow-left.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={HamburgerIcon} alt="Hamburger" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">hamburger.svg</span>
                            </div>
                        </div>
                    </div>

                </div>

                {/* 24x24 Arrows Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">Up / down 24x24</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">2 icons</p>
                    </div>

                    {/* Arrow Icons */}
                    <div className="space-y-4">
                        <div className="flex items-center gap-8">
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={ArrowUpIcon} alt="Arrow up, no outline" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">arrow-up.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={ArrowDownIcon} alt="Arrow down, no outline" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">arrow-down.svg</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* 24x24 Social Media Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">Social media 24x24</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">3 icons</p>
                    </div>

                    {/* Social Media Small Icons */}
                    <div className="space-y-4">
                        <div className="flex items-center gap-8">
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={XComIcon} alt="X (Twitter)" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">x-com.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={TelegramSmallIcon} alt="Telegram" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">telegram.svg</span>
                            </div>
                            <div className="flex flex-col items-center gap-2">
                                <div className="flex items-center justify-center">
                                    <img src={DiscordSmallIcon} alt="Discord" />
                                </div>
                                <span className="text-xs font-outfit text-white/60">discord.svg</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Big Icons Section */}
                <div className="space-y-5">
                    <div className="relative pb-5 border-b border-gray-400/60">
                        <h3 className="font-montserrat text-base font-bold">big (social media)</h3>
                        <p className="absolute right-0 top-7 text-sm font-montserrat font-medium">5 icons</p>
                    </div>
                    
                    <div className="flex items-center gap-12">
                        <div className="flex flex-col items-center gap-3">
                            <div className="flex items-center justify-center">
                                <img src={YoutubeIcon} alt="YouTube" className="w-16 h-16" />
                            </div>
                            <span className="text-sm font-outfit text-white/80 font-medium">youtube.svg</span>
                        </div>
                        <div className="flex flex-col items-center gap-3">
                            <div className="flex items-center justify-center">
                                <img src={KickIcon} alt="Kick" className="w-16 h-16" />
                            </div>
                            <span className="text-sm font-outfit text-white/80 font-medium">kick.svg</span>
                        </div>
                        <div className="flex flex-col items-center gap-3">
                            <div className="flex items-center justify-center">
                                <img src={XComBig} alt="Group" className="w-16 h-16" />
                            </div>
                            <span className="text-sm font-outfit text-white/80 font-medium">x-com.svg</span>
                        </div>
                        <div className="flex flex-col items-center gap-3">
                            <div className="flex items-center justify-center">
                                <img src={TelegramBigIcon} alt="Telegram" className="w-16 h-16" />
                            </div>
                            <span className="text-sm font-outfit text-white/80 font-medium">telegram.svg</span>
                        </div>
                        <div className="flex flex-col items-center gap-3">
                            <div className="flex items-center justify-center">
                                <img src={DiscordBigIcon} alt="Discord" className="w-16 h-16" />
                            </div>
                            <span className="text-sm font-outfit text-white/80 font-medium">discord.svg</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};